<!-- Chat Page -->
<div class="flex h-full max-h-screen">
  <div class="flex-1 flex flex-col min-h-0 w-full">
    <!-- Loading State -->
    @if (loading) {
      <div class="flex-1 flex items-center justify-center">
        <div class="text-center">
          <div class="w-16 h-16 border-4 border-light-primary dark:border-dark-primary border-t-transparent dark:border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p class="normal">Cargando chatbot...</p>
        </div>
      </div>
    } @else if (currentBot) {
      <!-- Chat Header -->
      <app-chat-header
        [botName]="currentBot.name"
        [botGradientStyle]="getBotGradientStyle()"
        [statusColorClass]="getStatusColor()"
        [statusText]="connected() ? 'Conectado' : 'Desconectado'"
        (onBack)="goBackToBots()"
      ></app-chat-header>

      <!-- Messages Area -->
      <div
        #messagesContainer
        class="flex-1 overflow-y-auto scrollbar-thin min-h-0 max-h-[calc(100vh-200px)] sm:max-h-[calc(100vh-240px)] md:max-h-[calc(100vh-280px)] !-my-7 dark:[color-scheme:dark]"
      >
        <div class="max-w-4xl mx-auto px-4 sm:px-6 py-4 sm:py-6 md:py-8 pb-4 w-full">
          <app-new-message-list [messages]="messages()" (sendMessage)="onSendMessage($event)" (scrollToBottom)="scrollToBottom()"></app-new-message-list>

          <!-- Typing Indicator -->
          @if (isTyping()) {
            <app-typing-indicator></app-typing-indicator>
          }
        </div>
      </div>

      <!-- Input Area -->
      <div class="input-container">
        <div class="max-w-4xl mx-auto w-full">
          <!-- Settings Info Bar -->
          <app-chat-info-bar
            [whatsappNumber]="whatsappNumber"
            [isSubscribed]="connection() === 'SUBSCRIBED'"
            [settingsTitle]="whatsappNumber ? 'Configuración' : 'Configuración - Requerido'"
            [settingsAriaLabel]="whatsappNumber ? 'Configuración' : 'Configuración requerida'"
            [canOpenBenchmark]="messages().length > 0 && !!sessionId()"
            benchmarkTitle="Ver benchmark de la conversación"
            benchmarkAriaLabel="Ver benchmark de conversación en vivo"
            (onNewSession)="startNewSession()"
            (onSettings)="openSettings()"
            (onCopyHistory)="copyChatToClipboard()"
            (onOpenBenchmark)="openLiveBenchmark()"
          >
            <div infoContent class="flex items-center">
              <span class="font-medium whitespace-nowrap">Número:</span>
              <span class="ml-1 truncate max-w-[120px] sm:max-w-none">{{ whatsappNumber }}</span>
            </div>
            <span infoContent class="hidden sm:inline">•</span>

            <!-- Session ID -->
            <div infoContent class="flex items-center">
              <button
                (click)="copySessionId()"
                class="flex items-center p-1 rounded-md hover:bg-light-bg-tertiary dark:hover:bg-dark-bg-tertiary transition-colors duration-200"
              >
                <lucide-angular [img]="ClipboardCopy" class="w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary"></lucide-angular>
                <span class="ml-1 font-medium whitespace-nowrap">Session ID:</span>
                <span class="ml-1 font-mono text-[0.7rem] sm:text-xs">{{ sessionId() }}</span>
              </button>
            </div>
            <span infoContent class="hidden sm:inline">•</span>

            <!-- Connection Status -->
            <div infoContent class="flex items-center">
              <span class="font-medium whitespace-nowrap">Conexión:</span>
              <span class="ml-1 font-mono text-[0.7rem] sm:text-xs">{{ connection() }}</span>
            </div>
          </app-chat-info-bar>

          <!-- Message Input -->
          <div class="message-input-bar flex items-center gap-2 rounded-lg p-1.5">
            <div class="flex-1 min-w-0">
              <app-message-input
                [(message)]="message"
                [placeholder]="whatsappNumber ? 'Escribe un mensaje...' : 'Configura tu WhatsApp para comenzar'"
                [disabled]="connection() !== 'SUBSCRIBED' || !whatsappNumber"
                [class.opacity-50]="connection() !== 'SUBSCRIBED' || !whatsappNumber"
                (sendMessage)="sendMessage()"
              >
              </app-message-input>
            </div>
          </div>

          <p class="small text-center !mt-3">
            En caso de cualquier error por favor contactar con
            <a
              href="mailto:equipo.ia.ti@copec.cl?subject=Error%20en%20Chatbot"
              class="text-light-primary dark:text-dark-primary hover:underline"
            >Equipo TI</a>
          </p>
        </div>
      </div>
    } @else {
      <!-- Bot Not Found -->
      <app-bot-not-found (onBack)="goBackToBots()"></app-bot-not-found>
    }
  </div>
</div>
